export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-mail-send-line"></i>
              投稿爆料
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 mt-2">有猛料？欢迎投稿！我们严格保护爆料人隐私</p>
          </div>

          <div className="max-w-lg mx-auto">
            <div className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-8">
              <div className="space-y-5">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">投稿邮箱</div>
                    <div className="text-sm text-foreground-500">tips@51chigua.com</div>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-xl text-accent-600"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">微信公众号</div>
                    <div className="text-sm text-foreground-500">搜索"51吃瓜爆料"</div>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-weibo-line text-xl text-secondary-700"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">微博</div>
                    <div className="text-sm text-foreground-500">@51吃瓜爆料网</div>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-background-200">
                <p className="text-xs text-foreground-400 leading-relaxed">
                  投稿请尽可能提供详细的时间、地点、人物和相关证据材料。我们会在收到投稿后24小时内进行评估和回复。所有投稿人信息将严格保密。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}